import React from "react";

import { Button as MuiButton, CircularProgress } from "@mui/material";

import uiConfig from "../config/uiConfig";

// Shared button matching the app's common style (height 38, no text-transform,
// rounded corners). Pass `loading` to auto-swap `startIcon` for a spinner and
// disable the button, instead of wiring that up manually at every call site.
function AppButton({
  variant = "contained",
  color,
  loading = false,
  startIcon,
  disabled,
  sx,
  children,
  ...rest
}) {
  const isPrimary = variant === "contained" && !color;

  return (
    <MuiButton
      variant={variant}
      color={color}
      disabled={disabled || loading}
      startIcon={loading ? <CircularProgress size={16} color="inherit" /> : startIcon}
      sx={{
        height: 38,
        textTransform: "none",
        borderRadius: 2,
        px: 2,
        ...(isPrimary
          ? {
              background: uiConfig.buttonColor,
              boxShadow: "none",
              "&:hover": { background: "#1d4ed8", boxShadow: "none" }
            }
          : {}),
        ...sx
      }}
      {...rest}
    >
      {children}
    </MuiButton>
  );
}

export default AppButton;
